import React, { useState, useEffect } from 'react';
import { Form, Input, Button, message, Select, Col, Row, Spin} from 'antd';
import { loginRequest } from '../../authConfig';
import { useMsal } from '@azure/msal-react';
import axios from 'axios';
import TextArea from 'antd/es/input/TextArea';

interface ManageHelpCategoryProps {
  helpCategoryId?: string | null;
}

const ManageHelpCategory: React.FC<ManageHelpCategoryProps> = ({helpCategoryId}) => {
  const [categoryName, setCategoryName] = useState('');
  const [description, setDescription] = useState('');
  const [categoryIcon, setCategoryIcon] = useState('');
  const [loading, setLoading] = useState<boolean>(false); // Loading state

  const { instance, accounts } = useMsal();

  const API_URL = process.env.REACT_APP_API_URL;

  const fetchToken = async () => {
        const res = await instance.acquireTokenSilent({
          ...loginRequest,
          account: accounts[0]
        });
        return res.idToken;
      };
    
      useEffect(() => {
        fetchToken();
        if (helpCategoryId != null) {
            loadHelpCategoryDataForEdit(helpCategoryId);
        }
      }, []);
      
    const loadHelpCategoryDataForEdit = async (helpCategoryId: string) => {
        try {
          const token = await fetchToken();
          const response = await axios.get(`${API_URL}/api/HelpCategory/GetHelpCategoryById/${helpCategoryId}`, {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            }
          });
          setCategoryName(response.data.helpCategoryName);
          setDescription(response.data.helpCategoryDescription);
          setCategoryIcon(response.data.helpCategoryIcon);
        } catch (error) {
          console.error("Error fetching help category details", error);
        }
    };

  const handleSubmit = async () => {
    if (!categoryName || !description || !categoryIcon) {
      message.error('Please fill all fields');
      return;
    }   
    
    setLoading(true); // Start loading

    const userId = localStorage.getItem("UserId");

    const formData = new FormData();
    formData.append('HelpCategoryName', categoryName);
    formData.append('HelpCategoryDescription', description);
    formData.append('HelpCategoryIcon', categoryIcon);
    formData.append('CreatedBy', userId || '');
    
    try {
        const token = await fetchToken();
        if(helpCategoryId != null) {
            //Update the data
            formData.append('HelpCategoryId', helpCategoryId || '');
            formData.append('UpdatedBy', userId || '');
            await axios.patch(`${API_URL}/api/HelpCategory/UpdateHelpCategoryData`, formData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data'
                }
            });
            message.success('Help category updated successfully');
        }
        else{
            //Add the data
            await axios.post(`${API_URL}/api/HelpCategory/SaveHelpCategoryData`, formData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data'
                }
            });
            message.success('Help Category added successfully');
        }
        setCategoryName('');
        setDescription('');
        setCategoryIcon('');
    } catch (error) {
        message.error('Failed to save the data');
    }
    finally {
      setLoading(false); // Stop loading
    }
  };

  return (
    <div>
      <Spin spinning={loading} tip="Submitting...">
      <div>
          <Form layout="vertical" onFinish={handleSubmit}>
            <Row gutter={16}>
                <Col span={12}>
                    <Form.Item label="Category Name" required>
                        <Input
                            value={categoryName}
                            onChange={(e) => setCategoryName(e.target.value)}
                            placeholder="Enter Category Name" maxLength={25}
                        />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item label="Category Icon" required>
                      <Select
                        value={categoryIcon || undefined}
                        onChange={(value) => setCategoryIcon(value)}
                        placeholder="Select Category Icon"
                        allowClear
                      >
                        <Select.Option value="AppleOutlined">Apple</Select.Option>
                        <Select.Option value="AndroidOutlined">Android</Select.Option>
                        <Select.Option value="WindowsOutlined">Windows</Select.Option>
                        <Select.Option value="QuestionCircleOutlined">QuestionCircle</Select.Option>
                        <Select.Option value="InfoCircleOutlined">InfoCircle</Select.Option>
                        <Select.Option value="ExclamationCircleOutlined">ExclamationCircle</Select.Option>
                        <Select.Option value="CheckCircleOutlined">CheckCircle</Select.Option>
                        <Select.Option value="CloseCircleOutlined">CloseCircle</Select.Option>
                        <Select.Option value="WarningOutlined">Warning</Select.Option>
                        <Select.Option value="PlusCircleOutlined">PlusCircle</Select.Option>
                        <Select.Option value="MinusCircleOutlined">MinusCircle</Select.Option>
                        <Select.Option value="CheckSquareOutlined">CheckSquare</Select.Option>
                        <Select.Option value="CloseSquareOutlined">CloseSquare</Select.Option>
                        <Select.Option value="StarOutlined">Star</Select.Option>
                        <Select.Option value="HeartOutlined">Heart</Select.Option>
                        <Select.Option value="LikeOutlined">Like</Select.Option>
                        <Select.Option value="DislikeOutlined">Dislike</Select.Option>
                        <Select.Option value="ShareAltOutlined">ShareAlt</Select.Option>
                        <Select.Option value="UserOutlined">User</Select.Option>
                        <Select.Option value="TrophyOutlined">Trophy</Select.Option>
                        <Select.Option value="BellOutlined">Bell</Select.Option>
                        <Select.Option value="CalendarOutlined">Calendar</Select.Option>
                        <Select.Option value="SettingOutlined">Setting</Select.Option>
                        <Select.Option value="CommentOutlined">Comment</Select.Option>
                        <Select.Option value="MessageOutlined">Message</Select.Option>
                        <Select.Option value="MailOutlined">Mail</Select.Option>
                        <Select.Option value="PhoneOutlined">Phone</Select.Option>
                        <Select.Option value="GlobalOutlined">Global</Select.Option>
                        <Select.Option value="LockOutlined">Lock</Select.Option>
                        <Select.Option value="UnlockOutlined">Unlock</Select.Option>
                        <Select.Option value="FileOutlined">File</Select.Option>
                        <Select.Option value="FolderOutlined">Folder</Select.Option>
                        <Select.Option value="GiftOutlined">Gift</Select.Option>
                        <Select.Option value="SoundOutlined">Sound</Select.Option>
                        <Select.Option value="StarOutlined">Star</Select.Option>
                      </Select>
                        {/* <Input
                            value={categoryIcon}
                            onChange={(e) => setCategoryIcon(e.target.value)}
                            placeholder="Enter Category Icon" maxLength={25}
                        /> */}
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={16}>
                <Col span={24}>
                    <Form.Item label="Description" required>
                        <TextArea
                            value={description} rows={5}
                            onChange={(e) => setDescription(e.target.value)}
                            placeholder="Enter Description" maxLength={75}
                        />
                    </Form.Item>
                </Col>
            </Row>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Save
            </Button>
          </Form.Item>
        </Form>
      </div>
      </Spin>
    </div>
    
  );
};

export default ManageHelpCategory;